import { useContext } from 'react'
import { ChatContext } from '../contexts/chat_context'
import { ChatTheme } from '../utils/theme'

export const useTheme = (): ChatTheme => {
  const { theme } = useContext(ChatContext)

  return theme
}
